/**
 * request_portfolio 卡片文案解析。
 * 兜底文案为 PRD 定稿：V3.0.6-引导链接Plaid流程优化 US2 S2.1 UI1
 * （§6 W-cardcopy 裁定）；接口（tool_call args）下发 title / description 时以接口为准。
 * 注：两段文案暂无 translate key（与 PlaidCategorySelectStep 同为硬编码），
 * 待 translate 专人流程补 key。
 */

/**
 * 后端 tool_call args 形状（保持宽松：字段全部可选）。
 * title / description 之外为旧版选项卡遗留，保留在类型上以兼容历史消息解析。
 */
export interface RequestPortfolioArgsLike {
  /** 卡片标题；接口未下发时取 PRD 兜底 */
  title?: string;
  /** 卡片副标题；接口未下发时取 PRD 兜底 */
  description?: string;
  connectLabel?: string;
  otherWaysLabel?: string;
  uploadStatementLabel?: string;
  snapPhotoLabel?: string;
  /** @deprecated use snapPhotoLabel */
  uploadLabel?: string;
  skipLabel?: string;
}

/** 交互态卡片头部文案（标题 + 副标题） */
export interface RequestPortfolioCardLabels {
  title: string;
  description: string;
}

const DEFAULT_REQUEST_PORTFOLIO_TITLE = "How would you like to connect?";
const DEFAULT_REQUEST_PORTFOLIO_DESCRIPTION =
  "Pick one to start. You can add the rest any time.";

/** request_portfolio 交互态 / 查看态共用的默认标题（PRD US2 S2.1 UI1） */
export const getDefaultRequestPortfolioLabels =
  (): RequestPortfolioCardLabels => ({
    title: DEFAULT_REQUEST_PORTFOLIO_TITLE,
    description: DEFAULT_REQUEST_PORTFOLIO_DESCRIPTION,
  });

export const resolveRequestPortfolioLabels = (
  args?: RequestPortfolioArgsLike,
): RequestPortfolioCardLabels => ({
  title: args?.title?.trim() || DEFAULT_REQUEST_PORTFOLIO_TITLE,
  description:
    args?.description?.trim() || DEFAULT_REQUEST_PORTFOLIO_DESCRIPTION,
});

/** args 有效即视为 request_portfolio 参数：title / description 任一为 string */
export const isRequestPortfolioArgs = (
  value: unknown,
): value is RequestPortfolioArgsLike => {
  if (!value || typeof value !== "object") {
    return false;
  }

  const candidate = value as RequestPortfolioArgsLike;

  return (
    typeof candidate.title === "string" ||
    typeof candidate.description === "string"
  );
};
